import React from 'react';
import { connect } from "react-redux";
import { wrapper } from "@/store";
import Footer from "@/bit/components/components.footer";
import Header from "@/bit/components/components.header";
import MetaData from "@/bit/core/core.meta-data";
import { getStaticProps as getStaticPropsMethod } from "@/bit/pages/pages.create-pages";
import FormHablanosDeTi from '@/component/formHablanosDeTi';

const questionMap = [
  ["phone"],
  ["personasHogar","movilMovistar","gustosTV", "plataformasTV", "otrosDispositivos"],
  ["vivienda", "satisfaccionWifi", "amplificadorWifi", "alarma"],
  ["segundaResidencia"],
  ["interesConectividad", "interesTV", "interesDispositivosHogar", "interesOtrosServicios", "modoContacto"],
  ["situacionLaboral", "consentimiento"]
];

const QUESTIONS = {
  phone: {
    typeQuestion: 'input',
    validation: 'phone',
    placeholder: 'Teléfono',
    required: true,
    ask: "Teléfono",
  },
  personasHogar: {
    titleText: "Las familias son tan diversas como nuestros clientes. ¿Nos cuentas cómo es la tuya? No te olvides de incluirte tú también.",
    typeQuestion: "personasHogar",
    required: true,
    ask: "¿Cuántas personas hay en tu hogar?"
  },
  movilMovistar: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Todos los que tenéis móviles tenéis líneas Movistar?",
    values: [
      {value: "Sí, todos los móviles de la familia son Movistar."},
      {value: "No, tenemos líneas con varios operadores.", nextQuestions: [ "otroOperadorMovil", "compromisoOperadorMovil"]},
    ]
  },
  otroOperadorMovil: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Con qué otros operadores se conecta tu familia?",
    values: [
      {value: "Vodafone"},
      {value: "Orange"},
      {value: "MasMovil"},
      {value: "DIGI"},
      {value: "Jazztel"},
      {value: "Lowi"},
      {value: "Yoigo"},
      {value: "Virgin"},
      {value: "Finetwork"},
      {value: "Grupo Euskaltel"},
      {value: "PARLEM"},
      {value: "R"},
      {value: "Telecable"},
      {value: "Otro operador"},
    ]
  },
  compromisoOperadorMovil: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Alguna de tus líneas tiene permanencia?",
    values: [
      {value: "No, no tengo permanencia"},
      {value: "Sí, menos de 3 meses"},
      {value: "Sí, entre 3-12 meses"},
      {value: "Sí, más de 12 meses"},
    ]
  },
  gustosTV: {
    typeQuestion: 'check',
    required: true,
    ask: "Cuando en tu familia os sentáis a ver la tele, ¿qué tipo de entretenimiento buscáis? Ya sabemos que es difícil ponerse de acuerdo, así que marca todas las opciones que os gusten",
    values: [
      {value: "Cine"},
      {value: "Series"},
      {value: "Documentales"},
      {value: "Fútbol"},
      {value: "Otros deportes"},
      {value: "Infantil"},
    ]
  },
  plataformasTV: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Qué plataformas de TV disfrutáis en casa?",
    values: [
      {value: "Ninguna"},
      {value: "Netflix"},
      {value: "Max"},
      {value: "Disney+"},
      {value: "Amazon Prime Video"},
      {value: "Movistar Plus+"},
      {value: "Apple TV"},
      {value: "Filmin"},
      {value: "Rakuten TV"},
      {value: "Cineclick"},
      {value: "DAZN"},
      {value: "Otros"}
    ]
  },
  otrosDispositivos: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Qué dispositivos utilizáis en el día a día?",
    values: [
      {value: "Tablet"},
      {value: "Smart TV"},
      {value: "Ordenador"},
      {value: "Smartphone"},
      {value: "Smartwatch"},
      {value: "Consola"},
    ]
  },
  vivienda: {
    titleText: "Para comprobar que nuestros servicios se adaptan a tu hogar, necesitamos hacerte unas preguntas sobre el lugar donde vives.",
    typeQuestion: 'radio',
    required: true,
    ask: "¿Cómo es tu vivienda habitual?",
    values: [
      {value: "Piso bajo"},
      {value: "Piso en altura"},
      {value: "Ático"},
      {value: "Chalet/Vivienda unifamiliar"},
    ]
  },
  // tipoPiso: {
  //   typeQuestion: 'radio',
  //   required: true,
  //   ask: "¿Qué tipo de piso?",
  //   values: [
  //     {value: "Piso bajo"},
  //     {value: "Piso en altura"},
  //     {value: "Ático"},
  //   ]
  // },
  // metrosVivienda: {
  //   typeQuestion: 'radio',
  //   required: false,
  //   ask: "¿Cuántos m2 tiene?",
  //   values: [
  //     {value: "menos de 90m2"},
  //     {value: "90m2 - 120m2"},
  //     {value: "121m2 -180 m2"},
  //     {value: "Más de 180 m2"}
  //   ]
  // },
  // conexionInternet: {
  //   typeQuestion: 'radio',
  //   required: true,
  //   ask: "En esta vivienda, ¿tienes conexión a Internet?",
  //   values: [
  //     {value: "Sí, tengo conexión a Internet",  nextQuestions: [ "operadorConexion", "permanenciaConexion"]},
  //     {value: "No, no tengo conexión a Internet"},
  //   ]
  // },
  // operadorConexion: {
  //   typeQuestion: 'radio',
  //   required: true,
  //   ask: "¿Cuál es tu operador de Internet?",
  //   values: [
  //     {value: "Movistar"},
  //     {value: "Vodafone"},
  //     {value: "Orange"},
  //     {value: "MasMovil"},
  //     {value: "DIGI"},
  //     {value: "Jazztel"},
  //     {value: "Lowi"},
  //     {value: "Yoigo"},
  //     {value: "Virgin"},
  //     {value: "Finetwork"},
  //     {value: "Grupo Euskaltel"},
  //     {value: "PARLEM"},
  //     {value: "R"},
  //     {value: "Telecable"},
  //     {value: "Otro operador"},
  //   ]
  // },
  // permanenciaConexion: {
  //   typeQuestion: 'radio',
  //   required: true,
  //   ask: "¿Tienes compromiso de permanencia con tu operador?",
  //   values: [
  //     {value: "No, no tengo permanencia"},
  //     {value: "Sí, menos de 3 meses"},
  //     {value: "Sí, entre 3-12 meses"},
  //     {value: "Sí, más de 12 meses"},
  //   ]
  // },
  satisfaccionWifi: {
    typeQuestion: 'select',
    required: true,
    ask: "En general, ¿estás satisfecho/a con la calidad de la red wifi de tu vivienda habitual? Valora tu satisfacción de 1 a 5, siendo 5 muy satisfecho/a y 1 nada satisfecho/a",
    values: [
      {value: "1", nextQuestions: ["motivoInsatisfaccionWifi", "metrosVivienda"]},
      {value: "2", nextQuestions: ["motivoInsatisfaccionWifi", "metrosVivienda"]},
      {value: "3", nextQuestions: ["motivoInsatisfaccionWifi", "metrosVivienda"]},
      {value: "4", nextQuestions: ["metrosVivienda"]},
      {value: "5", nextQuestions: ["metrosVivienda"]}
    ]
  },
  motivoInsatisfaccionWifi: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Por qué motivo no estás muy satisfecho?",
    values: [
      {value: "Baja velocidad"},
      {value: "Cortes en la conexión"},
      {value: "Zonas de la vivienda con mala cobertura"},
      {value: "Otros"}
    ]
  },
  metrosVivienda: {
    typeQuestion: 'radio',
    required: false,
    ask: "¿Cuántos m2 tiene?",
    values: [
      {value: "menos de 90m2"},
      {value: "90m2 - 120m2"},
      {value: "121m2 -180 m2"},
      {value: "Más de 180 m2"}
    ]
  },
  amplificadorWifi: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Tienes algún sistema de amplificación de la red wifi?",
    values: [
      {value: "No, no tengo ningún sistema de amplificación de la red wifi"},
      {value: "Sí, tengo un sistema de amplificación de la red wifi"},
    ]
  },
  alarma: {
    typeQuestion: 'radio',
    required: true,
    ask: "Para proteger tu hogar, ¿has contratado una alarma?",
    values: [
      {value: "No, no tengo alarma"},
      {value: "Sí, con Movistar Prosegur Alarmas"},
      {value: "Sí, con otro proveedor de seguridad", nextQuestions: ["compromisoAlarma"]},
    ]
  },
  compromisoAlarma: {
    typeQuestion: 'radio',
    required: true,
    ask: "Con tu proveedor de seguridad, ¿tienes compromiso de permanencia?",
    values: [
      {value: "< 3 meses"},
      {value: "3-12 meses"},
      {value: "> 12 meses"},
      {value: "Sin compromiso"}
    ]
  },
  segundaResidencia: {
    titleText: "Si tienes una segunda residencia, también queremos acompañarte en ella y conectarte con tu mundo desde allí. ¿Nos cuentas cómo es ese lugar especial para ti? Si aún no has encontrado tu segundo hogar, pasa a la siguiente página.",
    typeQuestion: 'radio',
    required: true,
    ask: "¿Tienes una segunda residencia?",
    values: [
      {value: "Si", nextQuestions: [ "tipoSegundaResidencia", "internetSegundaResidencia"]},
      {value: "No"},
    ]
  },
  tipoSegundaResidencia: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Cómo es tu segunda residencia?",
    values: [
      {value: "Piso bajo"},
      {value: "Piso en altura"},
      {value: "Ático"},
      {value: "Chalet/Vivienda unifamiliar"}
    ]
  },
  internetSegundaResidencia: {
    typeQuestion: 'radio',
    required: true,
    ask: "En esta segunda vivienda, ¿tienes conexión a Internet?",
    values: [
      {value: "Sí, tengo conexión a Internet", nextQuestions: ["operadorSegundaResidencia"]},
      {value: "No, no tengo conexión a Internet"},
    ]
  },
  operadorSegundaResidencia: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Cuál es tu operador de Internet?",
    values: [
      {value: "Movistar"},
      {value: "Vodafone", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Orange", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "MasMovil", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "DIGI", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Jazztel", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Lowi", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Yoigo", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Virgin", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Finetwork", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Grupo Euskaltel", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "PARLEM", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "R", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Telecable", nextQuestions: ["compromisoSegundaResidencia"]},
      {value: "Otro operador", nextQuestions: ["compromisoSegundaResidencia"]},
    ]
  },
  compromisoSegundaResidencia: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Tienes permanencia con tu operador en tu segunda residencia?",
    values: [
      {value: "No, no tengo permanencia"},
      {value: "Sí, menos de 3 meses"},
      {value: "Sí, entre 3-12 meses"},
      {value: "Sí, más de 12 meses​"}
    ]
  },
  interesConectividad: {
    titleText: "En Movistar, siempre estamos pensando en cómo hacer tu vida mejor con nuestros productos y servicios, pero tus necesidades pueden no ser las de tu vecino, tu amigo o tu familiar. ¿Puedes contarnos qué productos y servicios de Movistar son los que más te interesan? Marca todos los que quieras.",
    typeQuestion: 'check',
    required: true,
    ask: "¿Te interesan productos de Conectividad?",
    values: [
      {value: "Fijo"},
      {value: "Móvil"},
      {value: "Fibra"},
      {value: "miMovistar(Fijo, Móvil, Internet y TV)"},
      {value: "No, no me interesan"}
    ]
  },
  interesTV: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Te interesan productos de Televisión?",
    values: [
      {value: "Fútbol"},
      {value: "Deportes"},
      {value: "Cine y series"},
      {value: "Documentales"},
      {value: "No, no me interesan los productos de TV"}
    ]
  },
  interesDispositivosHogar: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Te interesa algún dispositivo para el hogar?",
    values: [
      {value: "Equipamiento para el hogar (routers, amplificadores, Descos, etcétera)"},
      {value: "Ofertas de smartphones"},
      {value: "Ofertas de otros dispositivos (Smart TVs, Belleza, ordenadores, etcétera)"},
      {value: "No, no me interesa ninguna de las opciones"},
    ]
  },
  interesOtrosServicios: {
    typeQuestion: 'check',
    required: true,
    ask: "¿Te interesa alguno de los siguientes servicios?",
    values: [
      {value: "Movistar Prosegur Alarmas"},
      {value: "Movistar Money: préstamos al consumo"},
      {value: "Solar 360"},
      {value: "Movistar Seguro de Hogar"},
      {value: "No, no me interesa ninguna de los servicios"},
    ]
  },
  modoContacto: {
    typeQuestion: 'check',
    required: false,
    ask: "A la hora de recibir comunicaciones y ofertas, ¿cuál es tu medio de contacto preferido?",
    values: [
      {value: "Por SMS"},
      {value: "Por email"},
      {value: "Por llamada telefónica"},
      {value: "Me gusta ver las ofertas en el menú de mi descodificador en la TV"},
    ]
  },
  situacionLaboral: {
    titleText: "Si podemos ayudarte en tu trabajo, estaremos preparados para hacerlo mejor:",
    typeQuestion: 'radio',
    required: true,
    ask: "¿Cuál es tu situación laboral?",
    values: [
      {value: "Trabajador por cuenta ajena"},
      {value: "Autónomo/Trabajador por cuenta propia", nextQuestions: ["ubicacionLaboral"]},
      {value: "Otros"}
    ]
  },
  ubicacionLaboral: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Trabajas desde casa o tienes un local/despacho/oficina?",
    values: [
      {value: "Trabajo desde casa"},
      {value: "Tengo un lugar de trabajo fuera de mi vivienda",  nextQuestions: ["metrosLaboral", "operadorLaboral"]},
    ]
  },
  metrosLaboral: {
    typeQuestion: 'radio',
    required: false,
    ask: "¿Cuántos m2 tiene el lugar donde trabajas? ",
    values: [
      {value: "menos de 90m2"},
      {value: "90m2 - 120m2"},
      {value: "121m2 -180 m2"},
      {value: "Más de 180 m2"}
    ]
  },
  operadorLaboral: {
    typeQuestion: 'radio',
    required: true,
    ask: "¿Quién es tu operador de Internet en tu lugar de trabajo?",
    values: [
      {value: "No tengo internet"},
      {value: "Movistar"},
      {value: "Vodafone"},
      {value: "Orange"},
      {value: "MasMovil"},
      {value: "DIGI"},
      {value: "Jazztel"},
      {value: "Lowi"},
      {value: "Yoigo"},
      {value: "Virgin"},
      {value: "Finetwork"},
      {value: "Grupo Euskaltel"},
      {value: "PARLEM"},
      {value: "R"},
      {value: "Telecable"},
      {value: "Otro operador"},
    ]
  },
  consentimiento: {
    typeQuestion: 'consentimiento',
    required: true,
    values: [{ value: 'Acepto el tratamiento de los datos aportados para su uso según los términos especificados en las condiciones de esta campaña.'}],
  },
}

const welcomeMessage = "¡Hola!</br></br>En Movistar, queremos ofrecerte cada día un servicio mejor, con productos que se adapten a ti y a tu familia, a lo que necesitas en tu hogar o en tu negocio. </br></br>Por eso, te agradeceríamos que respondieras a unas sencillas preguntas que nos ayudarán a conocerte mejor y a seguir conectando tu vida con lo que te importa.</br></br>Esta encuesta no te llevará más de 5 minutos.</br></br>Muchas gracias por tu tiempo y tu participación."

const createDefault = (questions) => {
    const res = {};
    Object.keys(questions).forEach(element => {res[element]= {value: '', error: '', valid: !questions[element].required}})
    return res;
}

const defaultValues = createDefault(QUESTIONS);
class HablanosDeTiCliente extends React.Component {

  render() {
    const { breadcrumbsProps, headerProps, seoInfo, footerProps } = this.props;
    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />
        <main>
        <FormHablanosDeTi default={defaultValues} welcomeMessage={welcomeMessage} questionMap={questionMap} questions={QUESTIONS} idForm="formulario-bi-clientes" idFormRetargeting="ret-hablanosdeticli-lead" />
        </main>

        <Footer footerProps={footerProps} />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  context: state.main.context,
  HablanosDeTiCliente: state.HablanosDeTiCliente,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(HablanosDeTiCliente);

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, "", 1, {
    pathname: "/hablanos-de-ti-cl",
    orionAlias: "",
    seoLocation: "www.movistar.es/hablanos-de-ti-cl",
    headerLocation: "/hablanos-de-ti-cl",
  });
});
